import { render } from "./Slide.vue?vue&type=template&id=238c894b&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=238c894b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238c894b"]])

export default __exports__